import { CsvUpload } from '@/features/csv-upload';
import { CreateItemTemplateDto, useBatchCreateItemTemplates } from '@/features/items/api';

import { ItemTemplateCsvPreview } from './item-template-csv-preview';
import {
  ItemTemplateCsvValidator,
  ItemTemplateCsvValidatorState,
} from './item-template-csv-validator';

export const ItemTemplateCsvUpload = () => {
  const { mutateAsync: batchCreateTemplates } = useBatchCreateItemTemplates();

  return (
    <CsvUpload<CreateItemTemplateDto, ItemTemplateCsvValidatorState>
      onSubmit={async (data) => {
        await batchCreateTemplates(data);
      }}
      ValidatorComponent={ItemTemplateCsvValidator}
      PreviewComponent={ItemTemplateCsvPreview}
    />
  );
};
